import React, { FC, MouseEvent, useCallback, useEffect, useMemo, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import Link from 'next/link';
import {
	UserDto,
	EventDto,
} from '@sweatpals/shared';
import { useStyles } from '@sweatpals/react-ui-kit';
import CommunityEvent from '../../../event/components/community-events/community-event.component';
import useLink from '@/modules/_core/hooks/useLink';
import { orderStyles } from './order.styles';

export const MoreHostEventsList = ({ host, hostEvents, href }: { host: UserDto, hostEvents: EventDto[], href: string }) => {
  const { makeHostLink, appLinkByOs } = useLink();
	const router = useRouter();
  const styles = useStyles(orderStyles);
	const hostPageUrl = useMemo(() => makeHostLink({ userName: host?.userName }), [host?.userName, makeHostLink]);

  const onLinkClick = useCallback((e: MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault();

		if (e.currentTarget.href) {
			router.push(e.currentTarget.href);
		}
	}, [router]);

	return (
    <Box display="flex" flexDirection="column" gap="26px">
      <Box
        sx={{
          gap: '16px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', sm: 'center' },
          flexDirection: { xs: 'column', sm: 'row' },
          px: { xs: '16px', sm: '0' }
        }}
      >
        <Typography sx={styles.communityEventsTitle}>
          More events from <Link href={href} onClick={onLinkClick} style={{ color: 'white' }} >{host?.fullName}</Link>
        </Typography>
        <Link href={href} passHref legacyBehavior onClick={onLinkClick} >
          <Box sx={styles.link}>See All</Box>
        </Link>
      </Box>
      {hostEvents?.map(event => (
        <CommunityEvent key={event.id} event={event} />
      ))}
    </Box>
	);
}
